import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ServiceMessageBrokerFactory,
  ServiceMessageBroker,
} from "shared/provider-webworker";
import { IOrderXferService } from "../IOrderXferService";
import { CubiqWorker } from "../../worker/CubiqWorker";
import { TraderGroupLookupService } from "../../lookup/model/impl/TraderGroupLookupService";

import { Subject } from "rxjs";

import * as CubiqTS from "shared/cubiq-model-multi-asset";

export abstract class OrderXferPromiseService implements IOrderXferService {
  abstract requestXfer(
    ids: Array<string>,
    comment: string,
    xferAction: CubiqTS.XferAction,
    targetGroupId: string,
    benchmarkXfer?: boolean,
  ): Promise<boolean>;
}
